import { takeEvery, put, fork, call } from 'redux-saga/effects';

import { Client } from '../utils/client';
import { ON_LOAD, onLoadSuccess, APP_LOGOUT, appLogoutSuccess, GET_LOGIN_USER_PROFILE, getLoginUserProfileSuccess } from './actions';
import baseConfig from './config.json';

export function* initSession() {
  Client.setBaseURL(process.env.REACT_APP_API_URL);

  const userObject = localStorage._u ? JSON.parse(localStorage._u) : null;

  if (userObject && userObject.authenticated) {
    Client.setToken(userObject.cogToken);
    Client.setMFAToken(userObject.mfaToken);
  }

  yield put(onLoadSuccess());
}

export function* getLoginUserProfile() {
  try {
    const userObject = localStorage._u ? JSON.parse(localStorage._u) : null;
    if (userObject && userObject.authenticated) {
      const userProfile = yield call(Client.getData, `/api/v1/portal/loginUser`, true);
      yield put(getLoginUserProfileSuccess(userProfile));
    }

  } catch (error) {
    console.log(error);
  }
}

export function* logoutSession() {
  Client.removeTokens();

  yield put(appLogoutSuccess());
}

function* watchOnLoad() {
  yield takeEvery(ON_LOAD, initSession);
  yield takeEvery(GET_LOGIN_USER_PROFILE, getLoginUserProfile);
}

function* watchLogout() {
  yield takeEvery(APP_LOGOUT, logoutSession);
}

export function* appSaga() {
  yield fork(watchOnLoad);
  yield fork(watchLogout);
}
